import {
  Component,
  inject,
  input,
  signal,
  OnInit,
  output,
} from "@angular/core";
import { Icon } from "../utils/icon/icon";
import { MobilityRefService } from "src/app/features/services/mobility/mobility-ref-service";
import { ContactCardInterface } from "src/app/core/interfaces/contact-card-interface";
import { TranslocoModule } from "@jsverse/transloco";

@Component({
  selector: "app-contact-card",
  imports: [Icon, TranslocoModule],
  templateUrl: "./contact-card.html",
  styles: [
    `
      :host {
        display: block;
        width: 100%;
        height: 100%;
      }
    `,
  ],
})
export class ContactCard implements OnInit {
  iconColor = input<"primary" | "secondary">("primary");
  spId = input.required<number>();
  name = input.required<string>();
  job = input.required<string>();
  entity = input<string>();
  photoUrl = input<string>();
  languages = input<string[]>();
  location = input<string[]>();
  mail = input<string>();
  phoneNumber = input<string>();
  bookingLink = input<string>();
  isInEditMode = input<boolean>(false);
  allowSaving = input<boolean>(false);

  openBookingCalendar(): void {
    window.open(this.bookingLink(), "_blank", "noopener,noreferrer");
  }

  isDeletedTicked = output<number>();

  isSaved = signal<boolean>(false);

  mobilityRefService = inject(MobilityRefService);

  async ngOnInit() {
    const isSaved = await this.mobilityRefService.getIsMobilityContactFavorite({
      spId: this.spId(),
    } as ContactCardInterface);
    this.isSaved.set(isSaved);
  }

  onSave(): void {
    this.mobilityRefService.postManyMobilityRefsFavorite([
      {
        spId: this.spId(),
      } as ContactCardInterface,
    ]);
    this.isSaved.set(true);
  }

  onDeleteRequired(): void {
    this.isDeletedTicked.emit(this.spId());
  }

  onUnsave(): void {
    this.mobilityRefService.deleteManyMobilityRefsFavorite([
      this.spId().toString(),
    ]);
    this.isSaved.set(false);
  }

  arrayToString(value: string[]): string {
    return value.join(", ");
  }

  hasText(value: string | null | undefined): boolean {
    return !!value && value.trim().length > 0;
  }
}
